import fontawesome from '@fortawesome/fontawesome'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import { faTimes, faEdit, faCog, faParagraph, faPencilAlt } from '@fortawesome/fontawesome-free-solid'

fontawesome.library.add(faTimes, faEdit, faCog, faParagraph, faPencilAlt)

export default FontAwesomeIcon



// WEBPACK FOOTER //
// ./src/fontawesome.js